// Opens the menu drawer on the Explore tab when the current page lives in Explore.
(function () {
  function norm(p) { return (p || '/').replace(/\/+$/, '') || '/'; }
  function init() {
    var drawer = document.getElementById('menu-drawer');
    var details = document.getElementById('Details-menu-drawer-container');
    if (!drawer) return;
    var panel = drawer.querySelector('[data-panel="explore"]');
    if (!panel) return;
    var here = norm(location.pathname);
    var match = null;
    panel.querySelectorAll('a[href]').forEach(function (a) {
      var p = norm(a.pathname);
      if (p === '/') return;
      if (here === p || here.indexOf(p + '/') === 0 || a.getAttribute('aria-current') === 'page') match = a;
    });
    if (!match) return;
    match.classList.add('menu-drawer__menu-item--active');
    match.setAttribute('aria-current', 'page');
    function showExplore() {
      drawer.querySelectorAll('.hd-drawer-tab').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.tab === 'explore' ? 'true' : 'false');
      });
      drawer.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== 'explore'; });
    }
    showExplore();
    if (details) details.addEventListener('toggle', function () { if (details.open) showExplore(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
